import { memo, useEffect, useRef } from 'react';
import './../../../style.css';
import { useDispatch, useSelector } from 'react-redux';
import {
  addViewedItemState,
} from '../../../../../../redux_store';

const ViewedTableCell = memo(({
                                children,
                                row,
                                canManageViewed,
                              }) => {
  const { viewState = {} } = useSelector((state) => state.table);
  const dispatch = useDispatch();
  const {
    notViewedUuids = [],
    wasSentViewedUuids = [],
  } = viewState;
  const ref = useRef();
  let observer;
  let sent = false;

  useEffect(() => {
    return () => observer && observer.disconnect();
  }, []);

  useEffect(() => {
    if (ref) {
      if (wasSentViewedUuids.includes(row?.uuid)) {
        ref?.current?.parentElement.parentElement.classList.remove(
          row?.errorType === true
            ? 'hoverNewErrorRow'
            : 'hoverNewRow',
        );
        ref?.current?.parentElement.parentElement.classList.add(
          row?.errorType  === true
            ? 'hoverViewedErrorRow'
            : 'hoverViewedRow',
        );
        if (observer) {
          observer.disconnect();
        }
      } else if (notViewedUuids.includes(row?.uuid)) {
        ref?.current?.parentElement.parentElement.classList.add(
          row?.errorType === true
            ? 'hoverNewErrorRow'
            : 'hoverNewRow',
        );
        if (!observer && canManageViewed) {
          observer = new IntersectionObserver((entries, _observer) => {
            entries.forEach(entry => {
              if (entry.intersectionRatio > 0 && !sent) {
                const uuid = row?.uuid;
                if (uuid && !wasSentViewedUuids.includes(uuid)) {
                  dispatch(addViewedItemState(uuid));
                }
                _observer.disconnect();
                sent = true;
              }
            });
          });
          observer.observe(ref?.current?.parentElement.parentElement);
        }
      }
    }
  }, [notViewedUuids, wasSentViewedUuids, ref]);


  return <div ref={ref} style={{maxWidth: '100%', width: '100%'}}>
    {children}
  </div>;
});

export default ViewedTableCell;
